import { ConfigService } from '../../'

/*& Models/Configs/Filter
	# FilterConfig
*/
export class FilterConfig {
	public color	= '#F00'
	public rows		= 3

	constructor(private config: ConfigService) {}

	update(config: any): FilterConfig {
		if (typeof config.filter === 'object') {
			this.color	= this.config.getColor(config.filter.color, this.color);
			this.rows		= typeof config.filter.rows === 'number' ? config.filter.rows : this.rows;
		}

		return this;
	}
}



// WEBPACK FOOTER //
// ./src/app/electraLib/model/config/filterConfig.ts